var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 48095695"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 97",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_3223_7847)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "profile-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.9987 56.6693C49.2034 56.6693 56.6654 49.2074 56.6654 40.0026C56.6654 30.7979 49.2034 23.3359 39.9987 23.3359C30.794 23.3359 23.332 30.7979 23.332 40.0026C23.332 49.2074 30.794 56.6693 39.9987 56.6693Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.1999 41.3034C40.0832 41.2867 39.9332 41.2867 39.7999 41.3034C36.8665 41.2034 34.5332 38.8034 34.5332 35.8534C34.5332 32.8367 36.9665 30.3867 39.9999 30.3867C43.0165 30.3867 45.4665 32.8367 45.4665 35.8534C45.4499 38.8034 43.1332 41.2034 40.1999 41.3034Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.2342 52.2977C48.2676 55.0143 44.3342 56.6643 40.0009 56.6643C35.6676 56.6643 31.7342 55.0143 28.7676 52.2977C28.9342 50.731 29.9342 49.1977 31.7176 47.9977C36.2842 44.9643 43.7509 44.9643 48.2842 47.9977C50.0676 49.1977 51.0676 50.731 51.2342 52.2977Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3223_7847",
    x1: 40,
    y1: 63,
    x2: 40,
    y2: 0.00000123704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6F9DA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalIcon);
export default __webpack_public_path__ + "static/media/personal_icon.b892173db937131cc3d4b89e7e935ae7.svg";
export { ForwardRef as ReactComponent };